import ApeIcon from '../components/ApeIcon';
import EthIcon from '../components/EthIcon';
import HoneyIcon from '../components/HoneyIcon';
import { Currency } from '../types';

const currencySymbols = {
  [Currency.Eth]: 'ETH',
  [Currency.Honey]: '$HONEY',
  [Currency.Ape]: '$APE',
};

const currencyIcons = {
  [Currency.Eth]: EthIcon,
  [Currency.Honey]: HoneyIcon,
  [Currency.Ape]: ApeIcon,
};

export const getCurrencySymbol = (currency: Currency) =>
  currencySymbols[currency];

export const getCurrencyIcon = (currency: Currency) => currencyIcons[currency];
